module.exports = __webpack_public_path__ + "media/images/countrysquared/jp-4c752ef69c7cb49118832053641615b0.svg";